import { inject, Injectable } from '@angular/core';
import { FirebaseService } from '../../common/firebase/firebase.service';
import {
  CreatePayoutRequestDto,
  CreatorPayoutBalances,
  CreatorPayoutListItem,
  PayoutDto,
  PayoutFilter,
  PayoutFilterCreator,
} from '../../common/general-types/payouts.dto';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { FilterCreatorsDto, FilterItemDto } from '@/app/common/general-types/filters.dto';

@Injectable({
  providedIn: 'root'
})
export class PayoutsService {

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  brandsFilterOptions: FilterItemDto[] = [];

  getFilteredPayoutsV2(filter: PayoutFilter): Observable<PayoutDto[]> {
    const filtered_payouts_v2_url = `${environment.shout_api.url}/payouts/filtered`;
    return this.http.post<any>(filtered_payouts_v2_url, filter, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getFancyPayouts(filters: FilterCreatorsDto) {
    const fancy_payouts_url = `${environment.shout_api.url}/payouts/filtered/fancy`;
    return this.http.post<any>(fancy_payouts_url, filters, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getFilterStats(): Observable<any> {
    const filter_stats_url = `${environment.shout_api.url}/payouts/fancy-filter-stats`;
    return this.http.get<any>(filter_stats_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  retryPayout(payoutId: string) {
    const retry_payout_url = `${environment.shout_api.url}/payouts/${payoutId}/retry`;
    return this.http.post<any>(retry_payout_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  createPayout(payload: CreatePayoutRequestDto): Observable<PayoutDto> {
    const create_payout_url = `${environment.shout_api.url}/payouts`;
    return this.http.post<PayoutDto>(create_payout_url, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  filterCreatorApplicationSpecific(briefApplicationId: string) {
    const filter_creator_application_specific_url = `${environment.shout_api.url}/payouts/filtered/creator/application-specific/${briefApplicationId}`;
    return this.http.get<any>(filter_creator_application_specific_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getAirwallexTransferById(payoutId: string) {
    const get_airwallex_transfer_by_id_url = `${environment.shout_api.url}/payments/admin/airwallex-transfer/by-id/${payoutId}`;
    return this.http.get<any>(get_airwallex_transfer_by_id_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getCreatorBalances(creatorId: string): Observable<CreatorPayoutBalances> {
    const url = `${environment.shout_api.url}/payouts/balances/admin/${creatorId}`;
    return this.http.get<CreatorPayoutBalances>(url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getCreatorPayouts(creatorId: string, filter: PayoutFilterCreator): Observable<CreatorPayoutListItem[]> {
    const url = `${environment.shout_api.url}/payouts/creator/${creatorId}`;
    return this.http.post<CreatorPayoutListItem[]>(url, filter, {
      headers: { 'Content-Type': 'application/json' },
    });
  }
}
